import { Bugsnag } from '../third-party'

/**
 * Check if we're running in production mode
 *
 * @returns {boolean}
 */
export const isProduction = () => process.env.NODE_ENV === 'production'

/**
 * Get SubDomain
 *
 * @returns {string}
 */
export const getSubdomain = function () {
  let subdomain = window.location.hostname.split('.')[0]
  switch (subdomain) {
    case 'www':
    case 'staging-www':
      break
    default:
      subdomain = 'local'
      break
  }

  return subdomain
}

/**
 * Check if the session is an admin
 * We do this by checking if the body has the class 'dv-team'
 * This is set in the server side template
 *
 * @returns {boolean} returns true if the user is an admin
 */
export const isDVTeam = function () {
  return $('body').hasClass('dv-team')
}

/**
 * Debug Console
 *
 * @param {mix} ...args
 * @returns {void}
 */
export function p (...args) {
  if (!isProduction()) {
    // eslint-disable-next-line no-console
    console.trace(...args)
  }
}

/**
 * Create Warning Alert Modal
 *
 * @param {String} title
 * @param {String} description
 * @param {Object} options Options to pass to the modal (used for callbacks)
 */
export function createAlert (title, description, options = {}) {
  // Create the modal
  const modalId = 'modal-' + Math.random().toString(36).substring(7)

  switch (options.alertType) {
    case 'success':
      options.alertType = 'check'
      break
    case 'info':
    case 'warning':
      break
    case 'danger':
      options.alertType = 'times'
      break
    default:
      options.alertType = 'warning'
      break
  }

  const modalHTML = `
  <div id="${modalId}" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="alertModal">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="alertModal">${title}</h4>
        </div>
        <div class="modal-body">
          <div class="modal-body_alert-warning">
            <i class="fa fa-${options.alertType} fa-4"></i>
            <p>${description}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  `

  // Append modal to body
  $('body').append(modalHTML)

  // Show modal
  $('#' + modalId).modal('show')

  // Add listener to close modal
  $('#' + modalId).on('hidden.bs.modal', function (e) {
    if (options.onHide) {
      options.onHide()
    }

    $('#' + modalId).remove()
  })
}

/**
 * Create Modal
 *
 * @param {String} title
 * @param {String} contentHtml
 * @param {Object} options Options to pass to the modal
 * @returns {jQuery} returns the jQuery object of the modal
 */
export function createModal (title, contentHtml, options = {}) {
  options = {
    showFooter: true,
    class: '',
    customFooter: '',
    size: 'md',
    showHeader: true,
    disableBackdrop: false,
    ...options
  }

  // Create the modal
  const modalId = 'modal-' + Math.random().toString(36).substring(7)
  const modalHTML = `
  <div id="${modalId}" class="modal fade ${options.class}" tabindex="-1" role="dialog" aria-labelledby="alertModal">
    <div class="modal-dialog modal-${options.size}" role="document">
      <div class="modal-content">
        ${options.showHeader
      ? `
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title" id="alertModal">${title}</h4>
            </div>
          `
      : ''}
        <div class="modal-body">
          ${contentHtml}
        </div>
        ${options.showFooter
      ? `
            <div class="modal-footer">
              ${options.customFooter || '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>'}
            </div>
          `
      : ''
    }
      </div>
    </div>
  </div>
  `
  // Append modal to body
  $('body').append(modalHTML)
  // Show modal
  $('#' + modalId).modal({
    show: true,
    backdrop: options.disableBackdrop ? 'static' : true,
    keyboard: !options.disableBackdrop
  })
  // Add listener to close modal
  $('#' + modalId).on('hidden.bs.modal', function (e) {
    $('#' + modalId).remove()
  })

  return $('#' + modalId)
}

/**
 * Analytics Event
 *
 * @param {String} event The event to send to Google Analytics
 */
export function analyticsEvent (event) {
  const gtag = window.gtag || undefined

  // This could happen if we're not in production
  if (!gtag) {
    return
  }

  /**
   * Get the basket contents
   *
   * @returns {Object} Returns the basket contents
   */
  const getBasketContents = () => {
    const $basket = $('#shoppingList')

    if (!$basket.length) {
      return []
    }

    let basketInfo = $basket.data('basket-info')

    if (!basketInfo) {
      return []
    }

    // Base 64 decode the basket info
    basketInfo = JSON.parse(atob(basketInfo))

    return basketInfo
  }

  /**
   * Save the basket snapshot
   *
   * @returns {void}
   */
  const saveBasketSnapshot = () => {
    const basketInfo = getBasketContents()

    // No basket info, so we can't do anything
    if (basketInfo.length === 0) {
      return
    }

    // Base64 encode the basket info and save it to local storage
    localStorage.setItem('basketSnapshot', btoa(JSON.stringify(basketInfo)))
  }

  /**
   * Get the basket snapshot
   *
   * @returns {Object} Returns the basket snapshot
   */
  const getBasketSnapshot = () => {
    const snapshot = localStorage.getItem('basketSnapshot')
    return snapshot ? JSON.parse(atob(snapshot)) : null
  }

  const snapshotInfo = getBasketSnapshot()

  /**
   * Observes an element and triggers a callback when it enters the viewport.
   *
   * @param {jQuery} $elements - The element(s) to observe.
   * @param {Function} callback - The function to call when the element enters the viewport.
   * @returns {void}
   */
  const observeElement = ($elements, callback) => {
    // No snapshot info, so we can't do anything
    if (!snapshotInfo) {
      return
    }

    // No elements to observe
    if (!$elements.length) {
      return
    }

    // Check if the Intersection Observer API is supported
    if (!('IntersectionObserver' in window)) {
      return
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // If the element is within the viewport
        // Then alert Google Analytics
        if (entry.isIntersecting) {
          const $entry = $(entry.target)

          // Callback
          callback($entry)

          // We don't want to keep observing this element since it's already been seen
          observer.unobserve(entry.target)
        }
      })
    }, {
      threshold: 1 // The element needs to be 100% in view within the viewport
    })

    $elements.each((_, element) => {
      observer.observe(element)
    })
  }

  // Reason why we do a try-catch is because we don't want to break the site if
  // there's a problem with the analytics
  try {
    switch (event) {
      case 'begin_checkout':
      {
        // Since we're starting a new checkout, we need to clear the snapshot
        localStorage.removeItem('basketSnapshot')

        const basketInfo = getBasketContents()

        // No basket info, so we can't do anything
        if (basketInfo.length === 0) {
          return
        }

        const items = []

        for (const key of Object.keys(basketInfo.items)) {
          const item = basketInfo.items[key]
          switch (key) {
            case 'accommodation':
              items.push({
                item_id: item.id,
                item_name: item.name,
                price: item.price,
                quantity: item.quantity
              })
              break
            case 'villa-extras':
              for (const extra of item.items) {
                items.push({
                  item_id: extra.id,
                  item_name: extra.name,
                  price: extra.price,
                  quantity: extra.quantity
                })
              }
              break
          }
        }

        saveBasketSnapshot()

        gtag('event', event, {
          currency: 'GBP',
          value: basketInfo.total,
          items
        })
        break
      }
      case 'update_checkout':
        {
          const basketInfo = getBasketContents()

          // No basket info, so we can't do anything
          if (basketInfo.length === 0) {
            // Clear the snapshot
            localStorage.removeItem('basketSnapshot')
            return
          }

          // If there's no basket snapshot, then we can't do anything
          if (!snapshotInfo) {
            return
          }

          /**
           * Update the extras
           *
           * Find out which extras has been updated and which have been removed
           *
           * @returns {void}
           */
          const updateExtras = () => {
            const extrasUpdated = []
            const extrasRemoved = []

            for (const extra of basketInfo.items['villa-extras'].items) {
              const snapshotExtra = snapshotInfo.items['villa-extras'].items.find(item => item.id === extra.id)

              if (!snapshotExtra || (snapshotExtra && snapshotExtra.quantity !== extra.quantity)) {
                extrasUpdated.push(extra)
              }
            }

            for (const extra of snapshotInfo.items['villa-extras'].items) {
              const basketExtra = basketInfo.items['villa-extras'].items.find(item => item.id === extra.id)

              if (!basketExtra) {
                extrasRemoved.push(extra)
              }
            }

            // Send event to Google Analytics
            if (extrasUpdated.length) {
              gtag('event', 'add_to_cart', {
                currency: 'GBP',
                value: extrasUpdated.reduce((total, extra) => total + (extra.price * extra.quantity), 0),
                items: extrasUpdated.map(extra => ({
                  item_id: extra.id,
                  item_name: extra.name,
                  price: extra.price,
                  quantity: extra.quantity
                }))
              })
            }

            if (extrasRemoved.length) {
              gtag('event', 'remove_from_cart', {
                currency: 'GBP',
                value: extrasRemoved.reduce((total, extra) => total + (extra.price * extra.quantity), 0),
                items: extrasRemoved.map(extra => ({
                  item_id: extra.id,
                  item_name: extra.name,
                  price: extra.price,
                  quantity: extra.quantity
                }))
              })
            }
          }

          /**
           * Update the flights
           *
           * Find out if flights have been added or removed
           *
           * @returns {void}
           * */
          const updateFlights = () => {
            // Check to see if flights have been added
            if (basketInfo.items.flights && !snapshotInfo.items.flights) {
              gtag('event', 'add_to_cart', {
                currency: 'GBP',
                value: basketInfo.items.flights.price,
                items: [{
                  item_id: basketInfo.items.flights.id,
                  item_name: basketInfo.items.flights.name,
                  price: basketInfo.items.flights.price,
                  quantity: 1
                }]
              })
            } else if (!basketInfo.items.flights && snapshotInfo.items.flights) {
              gtag('event', 'remove_from_cart', {
                currency: 'GBP',
                value: snapshotInfo.items.flights.price,
                items: [{
                  item_id: snapshotInfo.items.flights.id,
                  item_name: snapshotInfo.items.flights.name,
                  price: snapshotInfo.items.flights.price,
                  quantity: 1
                }]
              })
            } else if (basketInfo.items.flights && snapshotInfo.items.flights && basketInfo.items.flights.price !== snapshotInfo.items.flights.price) {
              gtag('event', 'add_to_cart', {
                currency: 'GBP',
                value: basketInfo.items.flights.price,
                items: [{
                  item_id: basketInfo.items.flights.id,
                  item_name: basketInfo.items.flights.name,
                  price: basketInfo.items.flights.price,
                  quantity: 1
                }]
              })
            }
          }

          /**
           * Update Tickets
           *
           * Find out if tickets have been added or removed
           *
           * @returns {void}
           */
          const updateTickets = () => {
            // Check to see if tickets have been added
            if (basketInfo.items.tickets && !snapshotInfo.items.tickets) {
              gtag('event', 'add_to_cart', {
                currency: 'GBP',
                value: basketInfo.items.tickets.price,
                items: basketInfo.items.tickets.items
              })
            } else if (!basketInfo.items.tickets && snapshotInfo.items.tickets) {
              gtag('event', 'remove_from_cart', {
                currency: 'GBP',
                value: snapshotInfo.items.tickets.price,
                items: snapshotInfo.items.tickets.items
              })
            } else if (basketInfo.items.tickets && snapshotInfo.items.tickets) {
              // Check to see if tickets have been updated
              if (basketInfo.items.tickets.price !== snapshotInfo.items.tickets.price) {
                const ticketsToRemove = snapshotInfo.items.tickets.items.filter(ticket => !basketInfo.items.tickets.items.find(item => item.id === ticket.id))
                const ticketsToAdd = basketInfo.items.tickets.items.filter(ticket => !snapshotInfo.items.tickets.items.find(item => item.id === ticket.id))

                if (ticketsToRemove.length) {
                  gtag('event', 'remove_from_cart', {
                    currency: 'GBP',
                    value: ticketsToRemove.reduce((total, ticket) => total + ticket.price, 0),
                    items: ticketsToRemove
                  })
                }

                if (ticketsToAdd.length) {
                  gtag('event', 'add_to_cart', {
                    currency: 'GBP',
                    value: ticketsToAdd.reduce((total, ticket) => total + ticket.price, 0),
                    items: ticketsToAdd
                  })
                }
              }
            }
          }

          /**
           * Update Car Hire
           *
           * Find out if car hire has been added or removed
           *
           * @returns {void}
           */
          const updateCarHire = () => {
            // Check to see if car hire has been added
            if (basketInfo.items.carHire && !snapshotInfo.items.carHire) {
              gtag('event', 'add_to_cart', {
                currency: 'GBP',
                value: basketInfo.items.carHire.price,
                items: basketInfo.items.carHire.items
              })
            } else if (!basketInfo.items.carHire && snapshotInfo.items.carHire) {
              gtag('event', 'remove_from_cart', {
                currency: 'GBP',
                value: snapshotInfo.items.carHire.price,
                items: snapshotInfo.items.carHire.items
              })
            } else if (basketInfo.items.carHire && snapshotInfo.items.carHire) {
              // Check to see if car hire has been updated
              if (basketInfo.items.carHire.price !== snapshotInfo.items.carHire.price) {
                gtag('event', 'add_to_cart', {
                  currency: 'GBP',
                  value: basketInfo.items.carHire.price,
                  items: basketInfo.items.carHire.items
                })
              }
            }
          }

          updateExtras()
          updateFlights()
          updateTickets()
          updateCarHire()

          saveBasketSnapshot()
        }
        break
      case 'purchase':
      {
        // If there's no basket snapshot, then we can't do anything
        if (!snapshotInfo) {
          return
        }

        // Build the items array
        const items = []

        // If there's no items in the snapshot, then we can't do anything
        if (!snapshotInfo.items) {
          break
        }

        // Loop through the items in the snapshot
        for (const key of Object.keys(snapshotInfo.items)) {
          const item = snapshotInfo.items[key]

          switch (key) {
            case 'flights':
            case 'accommodation':
              items.push({
                item_id: item.id,
                item_name: item.name,
                price: item.price,
                quantity: item.quantity
              })
              break
            case 'tickets':
            case 'carHire':
            case 'villa-extras':
              for (const extra of item.items) {
                items.push({
                  item_id: extra.id,
                  item_name: extra.name,
                  price: extra.price,
                  quantity: extra.quantity
                })
              }
              break
          }
        }

        gtag('event', 'purchase', {
          transaction_id: snapshotInfo.bookRef,
          currency: 'GBP',
          value: snapshotInfo.total,
          items
        })

        // Now remove the basket snapshot
        localStorage.removeItem('basketSnapshot')

        break
      }
      case 'view_tickets':
        observeElement($('.ticket'), function ($entry) {
          // Just get the first price in the passenger list, as the first price is the most expensive one
          // Replace £ and , with nothing
          const price = $entry.find('.ticket_content_info_season_price_info_price').first().text().trim().replace(/£|,/g, '')

          gtag('event', 'view_item', {
            currency: 'GBP',
            value: $entry.data('total-price'),
            items: [{
              item_id: $entry.data('ticket-id'),
              item_name: $entry.data('title'),
              price,
              quantity: 1
            }]
          })
        })
        break
      case 'view_villa_extras':
        observeElement($('.villa-optional-extra'), function ($entry) {
          gtag('event', 'view_item', {
            currency: 'GBP',
            value: $entry.data('extra-price'),
            items: [{
              item_id: $entry.data('extra-id'),
              item_name: $entry.data('extra-name'),
              price: $entry.data('extra-price'),
              quantity: 1
            }]
          })
        })
        break
      case 'view_flights':
        {
          const $flightSearchResults = $('.flight-search-results')

          if (!$flightSearchResults.length) {
            return
          }

          const flightSearchId = $flightSearchResults.data('flight-search-id')

          observeElement($flightSearchResults.find('.section'), function ($entry) {
            gtag('event', 'view_item', {
              currency: 'GBP',
              value: $entry.data('total'),
              items: [{
                item_id: flightSearchId,
                item_name: 'Flights',
                price: $entry.data('total'),
                quantity: 1
              }]
            })
          })
        }
        break
      case 'view_carhire':
        observeElement($('.car-result'), function ($entry) {
          gtag('event', 'view_item', {
            currency: $entry.data('currency'),
            value: $entry.data('total'),
            items: [{
              item_id: $entry.data('id'),
              item_name: 'Car Hire',
              price: $entry.data('total'),
              quantity: 1
            }]
          })
        })
        break
      case 'remarketing':
      {
        const $remarketing = $('#remarketing')

        if (!$remarketing.length) {
          return
        }

        let data = $remarketing.data('analytics')

        if (!data) {
          return
        }

        data = JSON.parse(atob(data))

        if (!data) {
          return
        }

        // This is a custom event which we use to target the remarketing audience
        gtag('event', 'remarketing', {
          ...data
        })

        // This is used for google ads to show the remarketing ad based on what the user has viewed
        gtag('event', 'view_item', {
          value: data.total,
          items: [{
            id: data.villaId,
            google_business_vertical: 'custom'
          }]
        })

        break
      }
      default:
        throw new Error('Invalid event type')
    }
  } catch (e) {
    if (isProduction()) {
      Bugsnag.notify(e)
    } else {
      // In local development, just log the error
      p(e)
    }
  }
}
